export default "__VITE_ASSET__BZKibXW7__"